<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <loading :active.sync="loadingCategoria"></loading>
  <b-row class="text-center mt-4">
    <b-col cols="1" md="3">
    </b-col>
    <b-col cols="9" md="6" >
      <b-row class="contenedorTablaSinColor" style="background:white ">
        <b-col cols="10" lg="11" class="pr-0">
          <b-input-group class="pl-3" >
            <b-form-input
                class="input-filter"
                v-model="filtro.nombreCategoriaPromocion"
                type="search"
                id="filterInput"
                responsive
                placeholder="Búsqueda de categoria promoción"
                @keydown.enter.native="buscarCategoriasPromocion()"
            >
            </b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="2" lg="1" class="pl-0">
      <b-button
          class="mt-1 pb-1"
          size="sm"
          variant="info"
          :disabled="loading"
          @click="buscarCategoriasPromocion"
          responsive
      >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
        <span v-else><b-spinner small></b-spinner></span>
      </b-button>
    </b-col>
    <b-col cols="1" class="text-left mt-auto mb-auto">
      <b-button
          variant="primary"
          v-b-tooltip.hover
          title="Alta de Categoria Promocion"
          class="paddingbotones botonesAzulFuerte"
          @click="altaCategoriaPromo()"
          responsive
          v-if="$localStorageService.can('Alt_cat_prom')"
      ><em class="vale_svg icon-boton"></em>
      </b-button>
    </b-col>
  </b-row>
    <b-row>
      <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
        <b-table
            :hover="true"
            :small="true"
            style="font-size: 12px !important; padding: 0.1rem;"
            responsive
            fixed
            :fields="fields"
            :items="items"
            :per-page="registrosPorPagina"
            :current-page="currentPage"
            thead-tr-class="columnasTablaSinColorLetter"
        >
          <template v-slot:cell(fechaAlta)="row">
            {{ row.item.fechaAlta | formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaModificacion)="row">
            {{ row.item.fechaModificacion | formatoFechaCorta }}
          </template>
          <template v-slot:cell(Acciones)="row" style="width: 200px">
            <b-button size="sm" variant="warning" class="mr-1 mt-1 marginbotones"
                      v-if="$localStorageService.can('Edit_cat_prom') && row.item.registroActivo"
                      v-b-tooltip.hover
                      title="Editar"
                      @click="editarCategoriaPromoModal(row.item)">
              <em class="editar_svg sm"></em>
            </b-button>

            <b-button size="sm" variant="outline-success" class="mr-1 mt-1 marginbotones"
                      v-if="!row.item.registroActivo && $localStorageService.can('Inac_cat_prom')"
                      v-b-tooltip.hover
                      title="Activar Categoria Promoción"
                      @click="desactivarActivar(row.item)">
              <em class="fa fa-undo"></em>
            </b-button>
            <b-button size="sm" variant="danger" class="mr-1 mt-1 marginbotones paddingbotones"
                      v-if="row.item.registroActivo && $localStorageService.can('Reac_cat_prom')"
                      v-b-tooltip.hover
                      title="Dar de baja"
                      @click="desactivarActivar(row.item)">
              <em class="eliminar_svg icon-boton"></em>
            </b-button>
          </template>
        </b-table>
        <div align="center" v-if="loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-else>
          <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
      </b-col>
      <div class="mt-2 w-100 flex justify-content-center align-items-end">
        <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="registrosPorPagina"
        ></b-pagination>
      </div>
    </b-row>
    <b-modal
        v-model="mostrarModal"
        size="xl"
        class="redondeo"
        centered
        :no-close-on-backdrop="true"
        hide-footer>
      <alta-categoria-promocion ref="modalModificar"
                                v-if="mostrarModal"
                                @cancelar="mostrarModal=false;"
                                :categoriaOriginal="categoriaPromoSeleccionada"
                                @actualizar="actuaBuscarCategoriasPromocion"></alta-categoria-promocion>
    </b-modal>
  </div>
</template>

<script>
import altaCategoriaPromocion from "./altaCategoriaPromocion";

export default {
  name: "listaCategoriaPromocion",
  components: {
    altaCategoriaPromocion
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loadingCategoria: false,
      filtro:{
        nombreCategoriaPromocion: ''
      },
      loading: false,
      fields: [
        {key: "idCategoriaPromocion", label: "ID Categoria Promoción", sortable: true},
        {key: "nombreCategoriaPromocion", label: "Nombre Categoria Promoción", sortable: true},
        {key: "descripcionCategoriaPromocion", label: "Descripción Categoria Promoción", sortable: true},
        {key: "fechaAlta", label: "Fecha Alta", sortable: true},
        {key: "fechaModificacion", label: "Fecha Modificación", sortable: true},
        {key: "usuarioModificacion", label: "Usuario Modificación", sortable: true},
        "Acciones",
      ],
      currentPage: 1,
      items: [],
      registrosPorPagina:10,
      mostrarModal: false,
      categoriaPromoSeleccionada: null
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.buscarCategoriasPromocion();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  watch:{
    "filtro.nombreCategoriaPromocion": async function () {
      if(this.filtro.nombreCategoriaPromocion === ''){
        setTimeout(() => {
          this.buscarCategoriasPromocion();
        }, 500)
      }
    }
  },
  methods: {
    buscarCategoriasPromocion() {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "categoriaPromocion/obtenerCategoriasPromocion",this.filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    actuaBuscarCategoriasPromocion(filtro) {
      this.currentPage = 1;
      this.loading = true;
      this.items = [];
      this.$http
          .post(this.$api + "categoriaPromocion/obtenerCategoriasPromocion",filtro)
          .then((response) => {
            this.items = response.data.data;
          }).finally(() => {
        this.loading = false;
      });
    },
    desactivarActivar(item) {
      const mensaje = item.registroActivo ?'¿Está seguro de desactivar la categoria promoción?': '¿Está seguro de activar la categoria promoción?';

      this.$swal.fire({
        icon: "warning",
        text: mensaje,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loading = true;
          this.$http
              .post(this.$api + "categoriaPromocion/activarDesactivarCategoriasPromocion", item)
              .then((response) => {
                if (response.data.data) {
                  this.buscarCategoriasPromocion();
                  this.$swal.fire({
                    position: "center",
                    icon: "info",
                    title: "Aviso",
                    text:  item.registroActivo ?'Se desactivó la categoria promoción': 'Se activo la categoria promoción',
                    showConfirmButton: false,
                    timer: 3500,
                  });
                }
              });
        },
      });
    },
    altaCategoriaPromo() {
      this.mostrarModal = true;
      this.titulo = "Nuevo categoria promoción";
      this.categoriaPromoSeleccionada = null;
      this.mostrarGuardar = true;
    },
    editarCategoriaPromoModal(item) {
      this.categoriaPromoSeleccionada = item;
      this.mostrarGuardar = false;
      this.mostrarModal = true;
      this.titulo = "Modificar categoria promoción";
    },
  }
}
</script>

<style scoped>
.paddingbotones {
  padding: 5px;
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}

</style>
